import { Div } from "../../../../base/components/native/div"
import { submitButtonStyle } from "./submit-button.style"

export const submitButton = (title: string = 'به روز رسانی موارد انتخاب شده') => {
    const base = Div(title)

    base.cssClass(submitButtonStyle)

    return Object.assign(base, {
        enable: () => {
            base.style({
                cursor: 'pointer', pointerEvents: 'auto',
                opacity: '1',
                filter: 'saturate(1)',

            })
        },
        disable: () => {
            base.style({
                cursor: '', pointerEvents: 'none',

                opacity: '.5',
                filter: 'saturate(.2)',
            })
        }
    })
}